module.exports = "/_next/static/images/SecurityAndPrivacy@2x-4d632ecb106ea90956cae4752b88f1c7.png";